module.exports = __webpack_public_path__ + "static/media/03.6f4c1b62.png";